import { render, staticRenderFns } from "./onebox-redirectpatment.vue?vue&type=template&id=4fd1ded9&"
import script from "./onebox-redirectpatment.vue?vue&type=script&lang=js&"
export * from "./onebox-redirectpatment.vue?vue&type=script&lang=js&"
import style0 from "./onebox-redirectpatment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports